// extracted by mini-css-extract-plugin
export var boxItems = "_2i-1";
export var boxItemsLg = "_2i-2";
export var button = "_2i-7";
export var buttonHoverless = "_2i-9";
export var buttonLg = "_2i-8";
export var filterGroupBox = "_2i-0";
export var icon = "_2i-3";
export var iconSecondary = "_2i-6";
export var iconWrapper = "_2i-4";
export var iconWrapperLg = "_2i-5";
export var truncatedLabel = "_2i-a";